import { Breadcrumb } from "react-bootstrap";
import { useFileNavigator } from "../../../context/FileNavigator";
import { useTranslation } from "react-i18next";

const FolderBreadcrumbs = () => {

    const { stateFN, dispatchFN, fetchDataFN } = useFileNavigator();
    const { t } = useTranslation(['FileNavigator']);

    const handleClickFolder = (index) =>{
        const _currentPath = stateFN.currentPathFN.split('/').slice(0, index+1).join('/');
        dispatchFN({type:'SET_CURRENT_PATH', payload:_currentPath});
    }   


    return (
        <div className="mb-4">
            <h6>{t('titleBreadcrumbs')}</h6>
            <Breadcrumb>

            {
                stateFN.currentPathFN.split('/').map((folder, index)=>{
                    return (
                        
                        <Breadcrumb.Item key={index}
                            active={stateFN.currentPathFN.split('/').length === index+1}
                            className="text-truncate folder-bread-item no-select"
                            onClick={()=>handleClickFolder(index)}>{(folder!=='') ? folder : t('rootFolder')}</Breadcrumb.Item>
                    )
                })
            }
            </Breadcrumb>
        </div>
        
    )
}

export default FolderBreadcrumbs;